import {
  Component,
  OnDestroy,
  OnInit,
  input,
  output
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  combineLatest,
  EMPTY,
  startWith,
  Subscription,
  switchMap,
  tap,
} from 'rxjs';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-checkbox-prop-filter',
    template: `
    <section>
      <h3>Status</h3>
      <section>
        <mat-checkbox [disabled]="!disabled.value" [formControl]="enabled">Enabled</mat-checkbox>
        <mat-checkbox [disabled]="!enabled.value"  [formControl]="disabled" class="ms-2"
          >Disabled</mat-checkbox
        >
      </section>
    </section>
  `,
    styles: [],
    imports: [MatCheckbox, FormsModule, ReactiveFormsModule]
})
export class CheckboxPropFilterComponent implements OnInit, OnDestroy {
  readonly formName = input<any>();

  enabled: UntypedFormControl = new UntypedFormControl(true);
  disabled: UntypedFormControl = new UntypedFormControl(false);

  readonly formGroup = input.required<UntypedFormGroup>();

  readonly values = input<any>([]);

  readonly changes = output<any>();

  private sub!: Subscription | undefined;

  constructor() {}

  ngOnInit(): void {

    this.checkboxControl?.valueChanges.pipe(
        tap((val) => {
          if(val === null) {
            this.enabled.setValue(true, {emitEvent: false});
            this.disabled.setValue(true, {emitEvent: false})
          }
          if(val === true) {
            this.enabled.setValue(true, {emitEvent: false});
            this.disabled.setValue(false, {emitEvent: false})
          }
          if(val === false) {
            this.enabled.setValue(false, {emitEvent: false})
            this.disabled.setValue(true, {emitEvent: false})
          }
        })
      )
      .subscribe();

    /* 
        null   -> both checked
        true   -> enabled checked
        false  -> disabled checked

    */

    const valuesChangeSub = combineLatest([
      this.enabled.valueChanges.pipe(startWith(false)),
      this.disabled.valueChanges.pipe(startWith(false)),
    ])
      .pipe(
        switchMap(([enabled, disabled]) => {
          // if both checkbox are disabled, check "enabled"
          if (!(enabled || disabled)) {
            setTimeout(() => this.enabled.setValue(true), 0);
            this.checkboxControl?.setValue(true);
          }

          // xnor
          if (enabled ^ disabled) {
            setTimeout(() =>
              this.changes.emit({ [this.formName()]: enabled === true })
            );
            this.checkboxControl?.setValue(enabled === true);
          }
          // if both are checked or unchecked get every user
          if (enabled && disabled) {
            setTimeout(() =>
              this.changes.emit({ [this.formName()]: `{"$in": [true, false]}` })
            );
            
            this.checkboxControl?.setValue(null);
          }

          return EMPTY;
        })
      )
      .subscribe();

    this.sub = valuesChangeSub;
  }

  get checkboxControl() {
    return this.formGroup().get(this.formName());
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
